import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { isRouteErrorResponse, Link, useRouteError } from 'react-router';

export const NotFound: FC = () => {
  const error = useRouteError();
  const { t } = useTranslation();

  let errorMessage: string;

  if (isRouteErrorResponse(error)) {
    // error is type `ErrorResponse`
    errorMessage = error.data?.message || error.statusText;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === 'string') {
    errorMessage = error;
  } else {
    console.error(error);
    errorMessage = 'Unknown error';
  }

  return (
    <div id="error-page" className="flex flex-col gap-8 justify-center items-center h-screen">
      <h1 className="text-4xl font-bold">{t('error.title')}</h1>
      <p>{t('error.subTitle')}</p>
      <p className="text-slate-400">
        <i>{errorMessage}</i>
      </p>
      <Link to="/" className="btn">
        {t('error.button')}
      </Link>
    </div>
  );
};
